var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer-class"},[_c('div',[_c('p',[_vm._v("copyrights © "+_vm._s(new Date().getFullYear())+" Don Quijote Recepciones | all rights reserved")])]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"33%","text-align":"right"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f75aff","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Index.vue
// module id = 176
// module chunks = 0